import { render, staticRenderFns } from "./ExpressLabelsTableUserTable.vue?vue&type=template&id=4b427b2e&scoped=true"
import script from "./ExpressLabelsTableUserTable.vue?vue&type=script&lang=js"
export * from "./ExpressLabelsTableUserTable.vue?vue&type=script&lang=js"
import style0 from "./ExpressLabelsTableUserTable.vue?vue&type=style&index=0&id=4b427b2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b427b2e",
  null
  
)

export default component.exports